import React from "react";
import PropTypes from "prop-types";
import Context from "shared/util/Context";
import Overlay from "shared/components/FullscreenOverlay";
import _str from "shared/util/_str";
import {
	selectedOptionOnNavBarEvent,
} from "./analytics";

import "./ProfileMenu.scss";

const ProfileMenu = ({ isOpen, onClose }) => {
	if (!isOpen) return null;

	const PROFILE_MENU_LINKS = [
		{
			displayText: _str("Profile"),
			path: "/profile",
		},
		{
			displayText: _str("Settings"),
			path: "/settings",
		},
		{
			displayText: _str("Help"),
			path: "https://help.okcupid.com/",
			target: "_blank",
		},
		{
			displayText: _str("Sign Out"),
			path: "/logout",
		},
	];

	if (Context.getSetting("DEPRECATE_BOOKMARKS") !== "FULL") {
		const BOOKMARKS_LINK = {
			displayText: _str("Bookmarks"),
			path: "/bookmarks",
		};

		// Place bookmarks after profile link.
		const profileIndex = PROFILE_MENU_LINKS.findIndex(({ path }) => path === "/profile");
		PROFILE_MENU_LINKS.splice(profileIndex + 1, 0, BOOKMARKS_LINK);
	}

	if (Context.get("isFlagMod")) {
		const FLAG_MOD_LINK = {
			displayText: _str("Review Photos"),
			path: "/flagmod",
		};

		// Place flagmod before sign out.
		const signOutIndex = PROFILE_MENU_LINKS.findIndex(({ path }) => path === "/logout");
		PROFILE_MENU_LINKS.splice(signOutIndex, 0, FLAG_MOD_LINK);
	}

	return (
		<React.Fragment>
			<div className="profile-menu">
				{PROFILE_MENU_LINKS
					.map((menuLink) => (
						<a
							key={menuLink.displayText}
							href={menuLink.path}
							className="profile-menu-link"
							onClick={() => {
								selectedOptionOnNavBarEvent(menuLink.displayText);
							}}
							target={menuLink.target}
						>
							{menuLink.displayText}
						</a>
					))
				}
			</div>
			<Overlay onClick={onClose} />
		</React.Fragment>
	);
};

ProfileMenu.defaultProps = {
	isOpen: false,
};

ProfileMenu.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
};

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/ProfileMenu.jsx